import React from 'react';
import AutomaticDebit from '../pages/AutomaticDebit';

export const automaticDebitRoutePage = {
  component: <AutomaticDebit />,
  route: '/debito-automatico',
};
